import {assocPath, concat} from "ramda";

const updateConfigLocale = (requestConfig, locale) => {
  const {baseURL, url} = requestConfig;
  const fullUrl = new URL(concat(baseURL, url));

  const shouldSet = locale && !fullUrl.searchParams.get("locale");

  return shouldSet
    ? assocPath(["params", "locale"], locale, requestConfig)
    : requestConfig;
};

export default updateConfigLocale;
